<template>
  <div class="work">
    <van-sticky>
      <van-dropdown-menu>
        <van-dropdown-item v-model="params.user_code" :options="opt_users" :title="title_user" @change="ChangeSelectUser" />
        <van-dropdown-item v-model="sel_date" :options="opt_dates" :title="title_date" @change="ChangeSelectDate" />
        <van-dropdown-item v-model="sel_state" :options="opt_status" />
        <van-dropdown-item v-model="sel_apply" :options="opt_applys" title="申请" @change="ChangeSelectApply" />
      </van-dropdown-menu>
    </van-sticky>
    <workdate v-show="sel_state=='0'" ref="workdate0" :status="'0'" />
    <leave v-show="sel_state=='1'" ref="leave" />
    <workdate v-show="sel_state=='2'" ref="workdate2" :status="'2'" />
    <workdate v-show="sel_state=='3'" ref="workdate3" :status="'3'" />
    <total v-show="sel_state=='4'" ref="total" />
    <van-popup v-model="picker.showDatePicker" position="bottom">
      <van-datetime-picker
        v-model="picker.currentDate"
        type="year-month"
        :min-date="picker.minDate"
        :max-date="picker.maxDate"
        @confirm="ConfirmDatePicker"
        @cancel="CancelDatePicker"
      />
    </van-popup>
    <van-popup v-model="popupleaveCreate" position="bottom" :style="{ height: '100%' }">
      <create v-if="existModel" ref="create" :mode="leavePage.mode" :info="leavePage.info" />
    </van-popup>
  </div>
</template>

<script>
import workdate from './Work/WorkDate'
import leave from './Work/Leave'
import total from './Work/Total'
import create from './Work/components/Create'
import request from '@/utils/request'
import { getUsercode } from '@/utils/auth'
import Vue from 'vue'
import { Tab, Tabs } from 'vant'

Vue.use(Tab)
Vue.use(Tabs)
const moment = require('moment')

export default {
  name: 'Work',
  components: { workdate, leave, total, create },
  data() {
    return {
      leavePage: {
        mode: true,
        info: {}
      },
      show: false,
      existModel: false,
      popupleaveCreate: false,
      picker: {
        minDate: new Date(2019, 0, 1),
        maxDate: new Date(moment().add(1, 'year').endOf('month')),
        currentDate: new Date(),
        showDatePicker: false
      },
      params: {
        user_code: this.$store.getters.usercode,
        work_date_s: moment().startOf('month').format('YYYY-MM-DD'),
        work_date_e: moment().endOf('month').format('YYYY-MM-DD')
      },
      isLoading: false,
      pageData: [],
      title_user: '用户',
      title_date: '本月',
      sel_date: '0',
      sel_state: '0',
      sel_apply: '',
      opt_users: [],
      opt_dates: [
        { text: '本月', value: '0', icon: 'clock-o' },
        { text: '前月', value: '1', icon: 'clock-o' },
        { text: '全年', value: '2', icon: 'clock-o' },
        { text: '自定义', value: '3', icon: 'aim' }
      ],
      opt_status: [
        { text: '全部', value: '0', icon: 'passed' },
        { text: '请假', value: '1', icon: 'info-o' },
        { text: '异常', value: '2', icon: 'question-o' },
        { text: '加班', value: '3', icon: 'gold-coin-o' },
        { text: '统计', value: '4', icon: 'todo-list-o' }
      ],
      opt_applys: [
        { text: '请假', value: '0', icon: 'todo-list-o' }
      ]
    }
  },
  watch: {
    pageData(value) {
      this.$refs.total.onRefresh(this.pageData)
    }
  },
  created() {
    const self = this

    if (getUsercode() === null) this.$router.push('/login')

    request({ url: '/C00/UserLists', params: { user_code: getUsercode() }})
      .then(function(response) {
        self.opt_users = response.data
        self.params.user_code = self.$store.getters.usercode
        self.title_user = self.FormartTitleUser(self.params.user_code)
      })
      .catch(() => { this.loading = false })
  },
  methods: {
    ChangeSelectUser(value) {
      this.params.user_code = value
      this.title_user = this.FormartTitleUser(this.params.user_code)
      this.onRefresh()
    },
    showPopup() {
      this.show = false
      this.onRefresh()
    },
    ChangeSelectDate(value) {
      switch (value) {
        case '0':
          this.params.work_date_s = moment().startOf('month').format('YYYY-MM-DD')
          this.params.work_date_e = moment().endOf('month').format('YYYY-MM-DD')
          this.title_date = this.opt_dates[value].text
          this.onRefresh()
          break
        case '1':
          this.params.work_date_s = moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD')
          this.params.work_date_e = moment().add(-1, 'month').endOf('month').format('YYYY-MM-DD')
          this.title_date = this.opt_dates[value].text
          this.onRefresh()
          break
        case '2':
          this.params.work_date_s = moment().startOf('year').format('YYYY-MM-DD')
          this.params.work_date_e = moment().endOf('year').format('YYYY-MM-DD')
          this.title_date = this.opt_dates[value].text
          this.onRefresh()
          break
        default:
          this.picker.showDatePicker = true
          this.sel_date = '9'
          break
      }
    },
    ConfirmDatePicker() {
      this.picker.showDatePicker = false
      if (moment(this.picker.currentDate).format('YYYY/MM') === moment().format('YYYY/MM')) {
        this.title_date = this.opt_dates['0'].text
      } else if (moment(this.picker.currentDate).format('YYYY/MM') === moment().add(-1, 'month').format('YYYY/MM')) {
        this.title_date = this.opt_dates['1'].text
      } else {
        this.title_date = moment(this.picker.currentDate).format('YYYY/MM')
      }
      this.params.work_date_s = moment(this.picker.currentDate).startOf('month').format('YYYY-MM-DD')
      this.params.work_date_e = moment(this.picker.currentDate).endOf('month').format('YYYY-MM-DD')
      this.onRefresh()
    },
    CancelDatePicker() {
      this.picker.showDatePicker = false
    },
    ChangeSelectApply(value) {
      this.sel_apply = '9'
      this.leavePage.mode = true
      this.leavePage.info = {}
      this.popupleaveCreate = true
      this.existModel = false
      this.$nextTick(() => { this.existModel = true })
    },
    closePopup() {
      this.popupleaveCreate = false
      this.onRefresh()
    },
    FormartTitleUser(value) {
      let temp
      this.opt_users.forEach(element => {
        if (element.value === value) {
          temp = element.text.split('(')[0]; return
        }
      })
      return temp
    },
    onRefresh() {
      this.$refs.workdate0.onRefresh()
      this.$refs.leave.onRefresh()
      this.$refs.workdate2.onRefresh()
      this.$refs.workdate3.onRefresh()
    }
  }
}
</script>
